/* 🤖 this file was generated by svg-to-ts */
export const svgInfo: {
    name: "info";
    data: string;
} = {
    name: "info",
    data: `<svg xmlns="http://www.w3.org/2000/svg"><symbol id="ng__info" fill="none" stroke-linecap="round" stroke-linejoin="round" class="ng__path-info" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 17v-5M12 8h0"/></symbol></svg>`,
};
